import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PagesSvg = function PagesSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E4602B",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22 17.833v.833H4.917a.417.417 0 1 1 0-.833zM8.965 13.987a.4.4 0 0 1 .092.07l.886.886a.417.417 0 0 1-.093.658l-3.267 1.815 1.815-3.267a.417.417 0 0 1 .567-.162m4.58-4.61 1.077 1.078a.417.417 0 0 1 0 .59l-3.577 3.577a.417.417 0 0 1-.59 0l-1.077-1.078a.417.417 0 0 1 0-.589l3.577-3.577a.417.417 0 0 1 .59 0m3.631-3.87a.932.932 0 0 1 1.316 1.316l-2.872 3.192-.008.008a.416.416 0 0 1-.59 0l-1.045-1.046-.015-.016a.417.417 0 0 1 .031-.588z",
    clipRule: "evenodd"
  }));
};
export var Pages = function Pages(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PagesSvg
  }));
};